import * as React from 'react';
import classNames from 'classnames';
import Icon from '@/components/ui/Icon';
import './styles.scss';

const Trend: React.FunctionComponent<{ value?: number; addOn?: string | null }> = (props) => {
  return (
    <div
      className={classNames('trend', {
        ['positive']: props.value && props.value > 0,
        ['negative']: props.value && props.value < 0,
      })}
    >
      {!!props.value && props.value > 0 && (
        <Icon
          width={16}
          height={16}
          kind="arrow01-up"
        />
      )}
      {!!props.value && props.value < 0 && (
        <Icon
          width={16}
          height={16}
          kind="arrow01-down"
        />
      )}
      {props.value === 0 && (
        <Icon
          width={16}
          height={16}
          kind="standing"
        />
      )}
      {typeof props.value === 'undefined' && (
        <Icon
          width={16}
          height={16}
          kind="blank"
        />
      )}
      {typeof props.value === 'undefined' ? (
        '-'
      ) : (
        <React.Fragment>
          {props.value}% {props.addOn}
        </React.Fragment>
      )}
    </div>
  );
};

Trend.displayName = 'Trend';

export default Trend;
